import _ from 'lodash';

import { SAFETY_FEATURE_STATUSES, SAFETY_FEATURE_STATUS_KEYS } from '../constants/statuses';

/*
  Merge RedBook safety features available on the vehicle into the safetyFeatureCategories object,
  so that the object contains RedBook safety features with availability statuses
  nested under TAC safety features, which are categorised under TAC Safety Feature categories.
*/
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'safetyFeatureCategories' implicitly has an 'any' type.
const mergeVehicleSafetyFeaturesIntoCategories = (safetyFeatureCategories, vehicleSafetyFeatures) => {
  const safetyFeatureCategoriesClone = _.cloneDeep(safetyFeatureCategories);
  const result = _.map(safetyFeatureCategoriesClone, ({ tacSafetyFeatureEntries, ...category }) => ({
    ...category,
    tacSafetyFeatureEntries: _.map(tacSafetyFeatureEntries, ({ redbookSafetyFeatureEntries, ...tacEntry }) => ({
      ...tacEntry,
      redbookSafetyFeatureEntries: _.map(redbookSafetyFeatureEntries, (redbookEntry) =>
        // _.merge(redbookEntry, _.find(vehicleSafetyFeatures, { id: redbookEntry.id }))
        _.merge(redbookEntry, _.find(vehicleSafetyFeatures, { equipcode: redbookEntry.redbookFeatureCode }))
      ),
    })),
  }));
  return result;
};

/*
  Calculate the status of a specific TAC Safety Feature,
  based on the availability of its child RedBook Safety Features.
*/
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'redbookSafetyFeatureEntries' implicitly has an 'any' type.
const getSafetyFeatureStatus = ({ redbookSafetyFeatureEntries }) => {
  const redbookSafetyFeatureStatuses = _.map(redbookSafetyFeatureEntries, ({ availability }) => availability);
  if (_.includes(redbookSafetyFeatureStatuses, SAFETY_FEATURE_STATUSES.STANDARD.databaseKey)) {
    return SAFETY_FEATURE_STATUS_KEYS.STANDARD;
  }
  if (_.includes(redbookSafetyFeatureStatuses, SAFETY_FEATURE_STATUSES.OPTIONAL.databaseKey)) {
    return SAFETY_FEATURE_STATUS_KEYS.OPTIONAL;
  }
  return SAFETY_FEATURE_STATUS_KEYS.NOT_INCLUDED;
};

export { getSafetyFeatureStatus, mergeVehicleSafetyFeaturesIntoCategories };
